import { useMemo } from "react";
import { POSITIONS } from "@besenliga/shared";
import { browserStore, loadRoster } from "../creator/roster";
import { currentRound, loadCareer } from "../career/career";
import { CLUB_NAMES } from "../flight/pilot";
import { tutorialBest } from "../training/TrainingScreen";

/** Menu principal (item 4.5): jogar, treinar, criar atleta e ver o estádio. */
export function MainMenu() {
  const roster = useMemo(() => loadRoster(browserStore()), []);
  const first = roster[0];
  const career = useMemo(() => loadCareer(browserStore()), []);
  const tutorialDone = useMemo(() => tutorialBest(browserStore()) !== null, []);
  return (
    <main className="menu-screen">
      <section className="menu-card" aria-labelledby="menu-titulo">
        <h1 id="menu-titulo" className="menu-logo">
          Besenliga
        </h1>
        <p className="menu-tagline">Esporte em vassouras, no seu navegador.</p>
        <nav className="menu-actions" aria-label="Menu principal">
          <a className="primary menu-main" href="#partida">
            Jogar partida
          </a>
          <a className="ghost" href="#online">
            Partida online
          </a>
          <a className="ghost" href="#carreira">
            {career
              ? `Carreira: rodada ${Math.min(10, (currentRound(career) ?? 9) + 1)} da temporada ${career.season}`
              : "Carreira offline"}
          </a>
          <a
            className={tutorialDone ? "ghost" : "ghost menu-new"}
            href={tutorialDone ? "#treino" : "#treino?tutorial"}
          >
            {tutorialDone ? "Treino: desafios e campo livre" : "Novo por aqui? Faça o tutorial"}
          </a>
          <a className="ghost" href="#criar">
            {first ? "Criar ou editar atletas" : "Criar seu atleta"}
          </a>
          <a className="ghost" href="#estadio">
            Ver o estádio
          </a>
        </nav>
        <p className="menu-athlete">
          {first ? (
            <>
              Em campo: <strong>{first.name}</strong> · {POSITIONS[first.position].label} ·{" "}
              {CLUB_NAMES[first.kit].full}
              {roster.length > 1 && ` (e mais ${roster.length - 1} no elenco)`}
            </>
          ) : (
            "Você ainda não criou um atleta: dá para jogar com o atleta de teste."
          )}
        </p>
      </section>
    </main>
  );
}
